import { render, staticRenderFns } from "./Centrali.vue?vue&type=template&id=55f2232a&"
import script from "./Centrali.vue?vue&type=script&lang=js&"
export * from "./Centrali.vue?vue&type=script&lang=js&"
import style0 from "./Centrali.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports